import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  invited: boolean;
  accepted: boolean;
  expired: boolean;
  isLoading: boolean;
};

const initialState: InitialState = {
  invited: false,
  accepted: false,
  expired: false,
  isLoading: false,
};

const invitationPageSlice = createSlice({
  name: "invitationPageSlice",
  initialState,
  reducers: {
    invite: (state, action) => {
      //
    },
    accept: (state, action) => {
      //
    },
    setInvited: (state) => {
      state.invited = true;
    },
    setAccepted: (state) => {
      state.accepted = true;
    },
    setExpired: (state) => {
      state.expired = true;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default invitationPageSlice;
